import React from 'react';
import Img from '../../Img';
import {
    CPP_UPGRADE_FEATURES,
    CPP_UPGRADE_SUBTITLE,
} from '../../Profile/CollegeProspectTab/MyTargetColleges/components/UpgradeToAnnualBanner';
import styles from './cppUpgradeLeftColumn.scss';

const CppUpgradeLeftColumn = () => (
    <div className={styles.container}>
        <div className={styles.subtitle}>
            {CPP_UPGRADE_SUBTITLE}
        </div>
        <div className={styles.features}>
            {CPP_UPGRADE_FEATURES.map((feature) => (
                <div key={feature.key} className={styles.feature}>
                    <Img
                        src={feature.iconSrc}
                        alt={feature.title}
                        className={styles.featureIcon}
                    />
                    <div className={styles.featureText}>
                        <div className={styles.featureTitle}>{feature.title}</div>
                        <div className={styles.featureDescription}>{feature.description}</div>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default CppUpgradeLeftColumn;
